import React from "react";

export const Footer = () => {
  return (
    // TODO: Corregir url linkedin
    <section className="footer container text-center">
      <p className="footer-heart">
        Made with 🦩 by{" "}
        <a href="https://www.linkedin.com/in/mjfbalice/">MJuliafb</a>
      </p>
    </section>
  );
};
